import classNames from 'classnames'

import Icons from '@/shared/components/icon/Icons'
import { Tint } from '@/shared/components/typography/index'

const NudgeBanner = ({ className }: { className?: React.ComponentProps<'div'>['className'] | null }) => {
  return (
    <a
      href={'https://page.modu.kr/referral/invitation?code=JOIN2APP'}
      className={classNames('flex w-full items-center justify-between rounded-md bg-gray-080 px-3 py-[6px]', className)}
    >
      <div className="flex items-center gap-2">
        <Icons.DiscountIcon />
        <Tint level="tint1" color="text010" weight="medium">
          지금 앱에서 구매하면 <span className="font-bold text-notice-050">50% 추가 할인</span>
        </Tint>
      </div>
      <Icons.LeftIcon className="text-white" />
    </a>
  )
}

export default NudgeBanner
